/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DictAttribute
 */
export interface DictAttribute {
    /**
     * 
     * @type {number}
     * @memberof DictAttribute
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DictAttribute
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DictAttribute
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DictAttribute
     */
    namePL: string;
}

export function DictAttributeFromJSON(json: any): DictAttribute {
    return DictAttributeFromJSONTyped(json, false);
}

export function DictAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictAttribute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'namePL': json['namePL'],
    };
}

export function DictAttributeToJSON(value?: DictAttribute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'namePL': value.namePL,
    };
}


